import { styled } from '@innowise-group/mui-kit';

export const Container = styled.div`
  margin-top: 2.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const Row = styled.div`
  column-gap: 0.5rem;
  display: flex;

  & .MuiFormControl-root,
  & .MuiAutocomplete-root {
    margin-top: 0;
    width: 100%;
  }
`;
